export default __webpack_public_path__ + "static/media/EOThero2.70331187.jpg";